import React from "react";
import Rating from "@material-ui/lab/Rating";
import StarBorderIcon from "@material-ui/icons/StarBorder";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
	root: {
		display: "flex",
		flexDirection: "column",

		"& > * + *": {
			marginTop: theme.spacing(1),
		},
	},
	"& .MuiRating-iconFilled": {
		color: "#ff6d75",
	},
}));

export default function HalfRating(props) {
	const classes = useStyles();
	return (
		<Rating
			emptyIcon={<StarBorderIcon fontSize="inherit" />}
			style={{ color: "var(--color-dark-blue)" }}
			name="size-large"
			size="large"
			defaultValue={props.rating}
			precision={0.1}
			readOnly={props.readOnly}
		/>
	);
}
